import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

type TruncatedCellProps = {
  content: React.ReactNode;
  plainText: string;
};

export const TruncatedCell: React.FC<TruncatedCellProps> = ({ content, plainText }) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        const el = textRef.current;
        setIsTruncated(el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight);
      }
    };
    checkTruncation();
  }, [plainText]);
  const handleMouseEnter = () => {
    if (textRef.current) {
      const rect = textRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.bottom + 4,
        left: rect.left,
      });
      setShowTooltip(true);
    }
  };
  return (
    <>
      <div 
        ref={textRef}
        className="overflow-hidden text-ellipsis whitespace-nowrap"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {content}
      </div>
      {showTooltip && isTruncated && createPortal(
        <div 
          className="fixed z-[9999] px-2 py-1 bg-gray-900 text-white text-xs rounded whitespace-nowrap pointer-events-none shadow-lg"
          style={{
            top: `${tooltipPosition.top}px`,
            left: `${tooltipPosition.left}px`,
          }}
        >
          {plainText}
        </div>,
        document.body
      )}
    </>
  );
};

